var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "primary-menu-config" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入中文名" },
                      model: {
                        value: scope.row.cnName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "cnName", $$v)
                        },
                        expression: "scope.row.cnName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "英文名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入英文名" },
                      model: {
                        value: scope.row.enName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enName", $$v)
                        },
                        expression: "scope.row.enName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标签" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入标签" },
                      model: {
                        value: scope.row.label,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "label", $$v)
                        },
                        expression: "scope.row.label",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "排序", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        max: 9999,
                        "controls-position": "right",
                      },
                      model: {
                        value: scope.row.sort,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "sort", $$v)
                        },
                        expression: "scope.row.sort",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否显示", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      model: {
                        value: scope.row.visible,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "visible", $$v)
                        },
                        expression: "scope.row.visible",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            { attrs: { type: "success" }, on: { click: _vm.handleSave } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览一级分类",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }